// DS: DS4.1
/** A styled radio button control for forms */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useImperativeHandle, useRef } from 'react';
import c from 'classnames';
import BiInput from '@wix/da-bi/pkg/Components/BiInput';
import { setRef } from '../../utils/refHelpers';
import s from './RadioButton.scss';
const RadioButton = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className, inputClassName, children, withMargins = false, size = 'medium', biData } = _param, rest = _object_without_properties(_param, [
        "className",
        "inputClassName",
        "children",
        "withMargins",
        "size",
        "biData"
    ]);
    const labelRef = useRef(null);
    const inputRef = useRef(null);
    useImperativeHandle(ref, ()=>({
            focus: ()=>{
                var _inputRef_current;
                (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
            },
            label: ()=>labelRef.current,
            input: ()=>inputRef.current
        }));
    return /*#__PURE__*/ React.createElement("label", {
        className: c(s['root'], withMargins && s['with-margins'], children && s['with-children'], s['new-colors'], s[size], className),
        ref: labelRef
    }, /*#__PURE__*/ React.createElement(BiInput, _object_spread({
        type: "radio",
        biData: biData,
        className: c(s['input'], inputClassName),
        innerRef: (node)=>setRef(inputRef, node)
    }, rest)), children);
});
RadioButton.displayName = 'RadioButton';
export default RadioButton;

//# sourceMappingURL=RadioButton.js.map